export const ERROR_MESSAGES = {
  unknown: 'Unknown error',
  logoutError: 'Error during logout',
  errorPageHeading: 'Что-то пошло не так!',
  errorPageMessages: [
    'Извините, пожалуйста, за причинённые неудобства.',
    'Мы уже работаем над проблемой и постараемся решить её в ближайшее время.'
  ]
};
